import axios from 'axios';

const token = process.env.REACT_APP_API_TOKEN;

const tmdb = axios.create({
  baseURL: 'https://api.themoviedb.org/3',
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export default tmdb;
